import { ObjectValues } from 'src/common/tsHelpers';

export const SIM_PRODUCT_ACTION = {
  ACTIVATE: 1,
  SUSPEND: 2,
  UNSUSPEND: 3,
  TERMINATE: 4,
  CANCEL_LOCATION: 5,
} as const;

export type SimProductAction = ObjectValues<typeof SIM_PRODUCT_ACTION>;
